// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"ManufacturingDefaultPage_placeholder__2so4C","fade":"ManufacturingDefaultPage_fade__w8Ud4"};